import React from 'react';
import styles from './Steps.module.css';

export interface StepsProps {
  children?: React.ReactNode;
  className?: string;
}

export interface StepProps {
  title?: string;
  stepNumber?: number;
  children?: React.ReactNode;
  className?: string;
}

export const Step: React.FC<StepProps> = ({
  title,
  stepNumber = 1,
  children,
  className = '',
}) => {
  return (
    <div className={`${styles.step} ${className}`.trim()}>
      <div className={styles.marker}>{stepNumber}</div>
      <div>
        {title && <h4 className={styles.title}>{title}</h4>}
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
};

export const Steps: React.FC<StepsProps> = ({ children, className = '' }) => {
  let stepIndex = 0;

  const mappedChildren = React.Children.map(children, (child) => {
    if (React.isValidElement<StepProps>(child)) {
      stepIndex++;
      const assignedNumber = child.props.stepNumber ?? stepIndex;
      return React.cloneElement(child, {
        stepNumber: assignedNumber,
      });
    }
    return child;
  });

  return <div className={`${styles.list} ${className}`.trim()}>{mappedChildren}</div>;
};

export default Steps;
